<template>
  <div class="gantt-view">
    <Loader :isVisible="loading" :loadingText="loadText"/>
    <!-- <div class="legends" v-if="ganttLegend.length > 0">
      <button @click="showLegend ^= true">Legends</button>
      <div class="legend-container" :style="{ height: showLegend ? `${(ganttLegend.length * 20) + ((ganttLegend.length + 1) * 5) + 12}px` : '0px',
        padding: showLegend ? '5px' : '0 5px', borderColor: showLegend ? 'gray' : 'transparent' }">
        <div class="legend-items" v-for="l in ganttLegend" :key="l">
          <div :style="{ height: '20px', width: '20px', backgroundColor: l.color, border: '1px solid rgba(64,64,64,0.3)' }"></div>
          <div class="legend-name">{{ l.name }}</div>
        </div>
      </div>
    </div> -->
    <div class="view-changer">
      <CheckBox v-if="showCheckBox" style="margin-right: 10px" :isChecked.sync="pendingChecked" title="Pending" checkColor="red" checkBackground="yellow"/>
      <CheckBox v-if="showCheckBox" style="margin-right: 10px" :isChecked.sync="dueChecked" title="Due"/>
      <CheckBox v-if="showCheckBox" style="margin-right: 10px" :isChecked.sync="completedChecked" title="Completed"/>

      <Dropdown v-if="showCategories" class="category-dropdown" fontSize="10" :items="categoryList" border="1px solid rgba(0,0,0,0.2)" borderRadius="5px"
        placeholder="Status Category" itemKey="Description" @selected="categorySelected" :selectedItem="categoryDesc"/>
      
      {{ dateTitle }}: 
      <DateTimePicker :value.sync="fromDate" :maxDate="toDate"/>
      &nbsp;To: 
      <DateTimePicker :value.sync="toDate" :minDate="fromDate"/>

      <button @click="refreshClicked()" style="margin-left: 5px">Refresh</button>
      <div class="zoom-range">
        <div>Grid Width</div>
        <input class="slider" type="range" min="25" step="1" max="300" v-model="taskWidth">
      </div>
    </div>

    <div v-if="showNoItems" class="no-items">
      {{ noItemsMsg }}
    </div>

    <Popup ref="popup"/>

    <div class="gantt-area">
      <div class="gantt" ref="gantt" :style="{ width: ganttLegend.length > 0 ? 'calc(100% - 100px)' : '100%' }"></div>
      <div class="legends">
        <div class="legend-items" v-for="l in ganttLegend" :key="l">
          <div :style="{ minHeight: '20px', minWidth: '20px', backgroundColor: l.color, marginRight: '3px' }"></div>
          <div>{{ l.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.js";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker.js";

import Loader from '@/components/Loader.vue';
import Dropdown from '@/components/Dropdown.vue';
import Popup from '@/components/GanttPopup.vue';
import CheckBox from '@/components/CheckBox.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

var totalSecs = 0;

export default {
  name: "gantt",
  components: {
    Loader, Dropdown, Popup, CheckBox, DateTimePicker
  },
  props: {
    tasks: { type: Object, default() { return { data: [], links: [] } } },
    myTasks: { type: Array, default: function() { return []; } },
    selectedRange: { type: String, default: '' },
    months: { type: Array, default: function() { return [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ]; } },
    currentView: { type: String, default: 'default' },
    showRange: { type: Boolean, default: false },
    taskWidth: { type: Number, default: 25 },
    showCheckBox: { type: Boolean, default: true },
    showCategories: { type: Boolean, default: true },
    dateTitle: { type: String, default: 'Date From' },

    zoomRangeClass: { type: String, default: 'zoom-range' },
    zoomRangeBtnClass: { type: String, default: 'btn' },

    loading: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },

    categoryList: { type: Array, default: function() { return []; } },
    selectedCategory: { type: String, default: '' },
    categoryDesc: { type: String, default: '' },
    showNoItems: { type: Boolean, default: false },

    checkGanttLeftDate: { type: Boolean, default: true },

    noItemsMsg: { type: String, default: '' },
    zoomDateTime: Date,

    popup: { type: Object, default: '' },

    pendingChecked: { type: Boolean, default: false },
    dueChecked: { type: Boolean, default: false },
    completedChecked: { type: Boolean, default: false },

    showLegend: { type: Boolean, default: false },

    // Public properties
    fromDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0) }, // The start date
    toDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59) }, // The end date
    dataFromServer: { type: Object, default: function() { return null } },
    ganttLegend: { type: Array, default: function() { return [] } },

    // Public events
    // loaded - fired when it is ready to pump data into the gantt
    // refreshClicked - fired when the refresh button is clicked
  },
  methods: {
    zoomClick: function(zoomIn) {
      if (zoomIn == true) {
        gantt.config.min_column_width += 5;
      } else {
        gantt.config.min_column_width -= 5;
      }

      gantt.init(this.$refs.gantt);
    },
    closeClick: function() {
      this.optionClass = "option-area option-hide";
      this.openBtnClass = "btn open disable-selection";
    },
    openClick: function() {
      if (this.zoomRangeClass == 'zoom-range') {
        this.zoomRangeClass = 'zoom-range zoom-range-open';
        this.zoomRangeBtnClass = 'btn flip';

        this.checkGanttLeftDate = false;
      } else {
        this.zoomRangeClass = 'zoom-range';
        this.zoomRangeBtnClass = 'btn';

        this.checkGanttLeftDate = true;
      }
    },
    changeView: function(range) {
      this.showRange = false;

      if (range == 'default') {
        this.selectedRange = '';
        this.currentView = 'default';

        gantt.config.scales = [
          { unit: "month", step: 1, format: "%F, %Y" },
          { unit: "day", step: 1, format: "%j, %D", css: this.today },
          { unit: "hour", step: 1, format: "%H" }
        ];

        gantt.config.start_date = new Date();
        gantt.config.end_date = new Date().setMonth(new Date().getMonth() + 1);
      } else if (range == 'day') {
        this.selectedRange = `${new Date().getDate()} ${this.months[new Date().getMonth()]}`;
        this.showRange = true;
        this.currentView = 'day';

        gantt.config.scales = [
          { unit: "month", step: 1, format: "%F, %Y" },
          { unit: "day", step: 1, format: "%j, %D", css: this.today },
          { unit: "hour", step: 1, format: "%H" }
        ];

        gantt.config.start_date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
        gantt.config.end_date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 0, 0, 0);
      } else if (range == 'month') {
        this.selectedRange = `${this.months[new Date().getMonth()]} ${new Date().getFullYear()}`;
        this.showRange = true;
        this.currentView = 'month';

        gantt.config.scales = [
          { unit: "month", step: 1, format: "%F, %Y" },
          { unit: "day", step: 1, format: "%j, %D", css: this.today },
          { unit: "hour", step: 1, format: "%H" }
        ];

        gantt.config.start_date = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0);
        gantt.config.end_date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1, 0, 0, 0);
      } else if (range == 'week') {
        gantt.config.scales = [
          { unit: "month", step: 1, format: "%F, %Y" },
          { unit: "day", step: 1, format: "%j, %D", css: this.today },
          { unit: "hour", step: 1, format: "%H" }
        ];

        var start = new Date();
        var end = new Date();
        var currentDay = new Date().getDay();

        if (currentDay == 0) {
          start = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
          end = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 6, 23, 59, 0);
        } else {
          start = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - currentDay, 0, 0, 0);
          end = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + (6 - currentDay), 23, 59, 0);
          // start = new Date().setDate(new Date().getDate() - currentDay);
          // end = new Date().setDate(new Date().getDate() + (6 - currentDay));
        }

        gantt.config.start_date = start;
        gantt.config.end_date = end;

        var newStart = new Date(gantt.config.start_date);
        var newEnd = new Date(gantt.config.end_date);

        if (newStart.getMonth() == newEnd.getMonth()) {
          this.selectedRange = `${newStart.getDate()} - ${newEnd.getDate()} ${this.months[newStart.getMonth()]}`;
        } else {
          this.selectedRange = `${newStart.getDate()} ${this.months[newStart.getMonth()]} - ${newEnd.getDate()} ${this.months[newEnd.getMonth()]}`;
        }
        
        this.showRange = true;
        this.currentView = 'week';
      }

      gantt.init(this.$refs.gantt);
      gantt.parse(this.$props.tasks);
    },
    today: function(date) {
      if (date.getDate() == new Date().getDate() && date.getMonth() == new Date().getMonth()) {
        return 'today-color';
      } else {
        return '';
      }
    },
    changeRange: function(direction) {
      var start = new Date(gantt.config.start_date);
      var end = new Date(gantt.config.end_date);

      if (this.currentView == 'day') {
        if (direction == 'next') {
          gantt.config.start_date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1, 0, 0, 0);
          gantt.config.end_date = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1, 0, 0, 0);
        } else if (direction == 'previous') {
          gantt.config.start_date = new Date(start.getFullYear(), start.getMonth(), start.getDate() - 1, 0, 0, 0);
          gantt.config.end_date = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 1, 0, 0, 0);
        }

        this.selectedRange = `${gantt.config.start_date.getDate()} ${this.months[gantt.config.start_date.getMonth()]}`;
      } else if (this.currentView == 'month') {
        if (direction == 'next') {
          gantt.config.start_date = new Date(start.getFullYear(), start.getMonth() + 1, 1, 0, 0, 0);
          gantt.config.end_date = new Date(end.getFullYear(), end.getMonth() + 1, 1, 0, 0, 0);
        } else if (direction == 'previous') {
          gantt.config.start_date = new Date(start.getFullYear(), start.getMonth() - 1, 1, 0, 0, 0);
          gantt.config.end_date = new Date(end.getFullYear(), end.getMonth() - 1, 1, 0, 0, 0);
        }

        this.selectedRange = `${this.months[gantt.config.start_date.getMonth()]} ${gantt.config.start_date.getFullYear()}`;
      } else if (this.currentView == 'week') {
        if (direction == 'next') {
          start.setDate(start.getDate() + 7);
          gantt.config.start_date = new Date(start);
          start.setDate(start.getDate() + 7);
          gantt.config.end_date = new Date(start);
        } else if (direction == 'previous') {
          start.setDate(start.getDate() - 7);
          gantt.config.start_date = new Date(start);
          start.setDate(start.getDate() + 7);
          gantt.config.end_date = new Date(start);
        }

        var newStart = new Date(gantt.config.start_date);
        var newEnd = new Date(gantt.config.end_date);

        if (newStart.getMonth() == newEnd.getMonth()) {
          this.selectedRange = `${newStart.getDate()} - ${newEnd.getDate()} ${this.months[newStart.getMonth()]}`;
        } else {
          this.selectedRange = `${newStart.getDate()} ${this.months[newStart.getMonth()]} - ${newEnd.getDate()} ${this.months[newEnd.getMonth()]}`;
        }
      }

      gantt.init(this.$refs.gantt);
      gantt.parse(this.$props.tasks);
    },
    categorySelected: function(item) {
      this.selectedCategory = item.StatusListCategory.trim();
      this.categoryDesc = item.Description;
    },
    onLoad: function() {
      this.$emit('loaded');
    },
    refreshClicked: async function() {
      this.$emit('refreshClicked');
    },
    deleteAll: function() {
      gantt.clearAll();

      var markerId = gantt.addMarker({
        start_date: new Date(), //a Date object that sets the marker's date
        css: 'marker', //a CSS class applied to the marker
        text: 'Now', //the marker title
        // title: 'testing' // the marker's tooltip
      });

      setInterval(() => {
        var today = gantt.getMarker(markerId);
        today.start_date = new Date();
        gantt.updateMarker(markerId);
      }, 1000 * 60);

      this.tasks = { data: [], links: [] };
      this.myTasks = [];

      gantt.init(this.$refs.gantt);
    },
    ganttScroll: function(left, top) {
      if (this.checkGanttLeftDate == true) {
        var boxes = (left / gantt.config.min_column_width);
        var start = gantt.config.start_date;

        this.zoomDateTime = new Date(start.getTime() + (boxes * 60 * 60 * 1000));
      }
    },
    ganttTaskClick: function(id, e) {
      if (id) {
        var data = [];

        this.myTasks.forEach(t => {
          data.push(JSON.parse(t));
        });

        var item = data.filter((d) => {
          return d.id == id;
        });

        var itemClicked = item[0];

        if (!itemClicked.parent) {
          return;
        }

        var itemDate = this.$dateTime.stringToDate(itemClicked.start_date, '-');
        var start = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate(), itemDate.getHours(), 0, 0);
        var end = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate(), itemDate.getHours() + 1, 0, 0);

        var allChild = data.filter((d) => {
          return d.parent == itemClicked.parent;
        });

        var childWithinHour = allChild.filter((a) => {
          return this.$dateTime.stringToDate(a.start_date, '-') >= start && this.$dateTime.stringToDate(a.start_date, '-') <= end;
        });

        // console.log(childWithinHour);

        var sortedChild = childWithinHour.sort((s, e) => {
          var start = this.$dateTime.stringToDate(s.start_date, '-');
          var end = this.$dateTime.stringToDate(e.start_date, '-');

          return start - end;
        });

        // console.log(JSON.stringify(sortedChild));

        // this.$refs.popup.show(sortedChild, start, end);
      }
    }
  },
  watch: {
    taskWidth: function(val) {
      gantt.config.min_column_width = parseInt(val);

      gantt.init(this.$refs.gantt);
      gantt.showDate(this.zoomDateTime);
    },
    fromDate: function(val) {
      this.$emit('update:fromDate', val);
    },
    toDate: function(val) {
      this.$emit('update:toDate', val);
    },
    dataFromServer: function(val) {
      if (val == null) {
        this.deleteAll();
        return;
      }

      if (val.data.length <= 0) {
        this.deleteAll();
        return;
      }

      this.tasks.data = val.data;

      this.tasks.data.forEach((d) => {
        this.myTasks.push(JSON.stringify(d));
      });

      var start = new Date(val.ganttStart);
      var end = new Date(val.ganttEnd);

      start.setSeconds(0);
      end.setSeconds(0);

      if (start.getMinutes() > 30) {
        start.setMinutes(30);
      } else {
        start.setMinutes(0);
      }

      if (end.getMinutes() > 30) {
        end.setHours(end.getHours() + 1);
        end.setMinutes(0);
      } else {
        end.setMinutes(30);
      }

      gantt.config.start_date = start;
      gantt.config.end_date = end;

      gantt.config.columns = [
        { name: 'col1Text', label: val.title[0], align: 'left', width: '*', tree: true },
        { name: 'col2Text', label: val.title[1], align: 'center', width: '*' },
        { name: 'col3Text', label: val.title[2], align: 'center', width: '20' },
      ];

      gantt.init(this.$refs.gantt);
      gantt.parse(this.$props.tasks);

      var opening = new Date().getTime();
      this.tasks.data.forEach((d) => {
        if (!d.parent) {
          gantt.open(d.id);
        }
      });
    }
  },
  mounted() {
    gantt.config.scale_height = 65;
    gantt.config.min_column_width = 25;

    gantt.config.grid_width = 350;

    gantt.config.duration_unit = "minute";
    gantt.config.duration_step = 30;

    gantt.config.drag_resize = false;
    gantt.config.drag_move = false;
    gantt.config.drag_links = false;
    gantt.config.drag_progress = false;

    gantt.config.row_height = 25;

    gantt.config.columns = [
      { name: 'text', label: 'Task', align: 'left', tree: true },
      { name: 'start_date', label: 'Date', align: 'center'},
      { name: 'cust', label: 'Customer', align: 'center' },
    ];

    gantt.config.scales = [
      { unit: "month", step: 1, format: "%F, %Y" },
      { unit: "day", step: 1, format: "%j, %D", css: this.today },
      { unit: "minute", step: 30, format: "%H:%i" },
      // { unit: "minute", step: 30, format: "%i" }
    ];

    gantt.templates.rightside_text = function(start, end, task) {
      if (task.rightText) {
        return `<div style="font-size: ${task.rightSize}px; margin-left: -18px;
                  margin-top: -4px">
                  ${task.rightText}
                </div>`;
      }
    };

    gantt.templates.leftside_text = function(start, end, task) {
      if (task.leftText) {
        // return `<div style="font-size: ${task.leftSize}px; margin-right: -18px; background-color: white">
        return `<div style="font-size: ${task.leftSize}px; margin-right: -18px;
                  display: flex; align-items: center; margin-top: 4px">
                  <span style="font-size: 20px">•</span>${task.leftText}
                </div>`;
      }
    };

    var markerId = gantt.addMarker({
      start_date: new Date(), //a Date object that sets the marker's date
      css: 'marker', //a CSS class applied to the marker
      text: 'Now', //the marker title
      // title: 'testing' // the marker's tooltip
    });

    setInterval(() => {
      var today = gantt.getMarker(markerId);
      today.start_date = new Date();
      gantt.updateMarker(markerId);
    }, 1000 * 60);

    gantt.attachEvent('onGanttScroll', this.ganttScroll);
    gantt.attachEvent('onTaskClick', this.ganttTaskClick);

    gantt.init(this.$refs.gantt);
    gantt.parse(this.$props.tasks);

    this.popup = this.$refs.popup;

    this.onLoad();
  },
  beforeDestroy() {
    gantt.detachAllEvents();
    localStorage.setItem('ganttRefresh', '0');
  }
};
</script>

<style lang="scss" scoped>
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
@import "@/css/all.scss";

$viewChangeHeight: 40px;
$borderColor: rgba(0,0,0,0.2);

.gantt-view {
  position: relative;
  font-size: 0.8em;
  overflow: hidden;

  // .legends {
  //   position: absolute;
  //   padding: 5px 10px;
  //   z-index: 4;

  //   .legend-container {
  //     margin-top: 2px;
  //     height: 100%;
  //     overflow: hidden;
  //     white-space: nowrap;
  //     border: 1px solid gray;
  //     border-radius: 3px;
  //     padding: 5px;
  //     background-color: #fff;
  //     transition: $transition-time;

  //     > * {
  //       margin: 5px 0;
  //     }

  //     .legend-items {
  //       display: flex;
  //       align-items: center;

  //       .legend-name {
  //         margin-left: 3px;
  //       }
  //     }
  //   }
  // }
}

.date-time {
  margin: 0 3px;
}

.option-area {
  // background-color: yellow;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 2;
  width: 30px;
  height: calc(100% - #{$viewChangeHeight});
  right: 0;
  transform: translateX(30px);
  transition: $transition-time;
}

.view-changer {
  background-color: white;
  height: $viewChangeHeight;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 5px;
}

.view-changer .btn {
  font-size: 1em;
  border: 1px solid $borderColor;
  border-radius: 5px;
}

.option-hide {
  transform: translateX(0);
}

.gantt-btn {
  padding: 0 10px;
  margin: 5px 0;
  /* height: 10px; */
}

.gantt-btn:focus {
  outline: none;
}

// Region Range
.range {
  // background-color: red;
  display: flex;
  align-items: center;
  margin-right: 10px;
  font-size: 0.8em;
}

.range-changer {
  padding: 0 10px;
  // background-color: yellow;
}

.range-changer:hover {
  cursor: pointer;
}
// End Region Range

.no-items {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: rgba(225,225,225,0.75);
  width: 100%;
  height: 100%;
  z-index: 20;
  white-space: pre-line;
}

.btn {
  background-color: white;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.2);
  padding: 0 10px;
  border-radius: 0;
  transition: $transition-time;
  margin: 5px;
}

.open {
  position: absolute;
  z-index: 1;
  left: 100%;
  top: $viewChangeHeight;
}

.btn-hide {
  opacity: 0;
}

.btn:hover {
  cursor: pointer;
}

.flip {
  transform: scaleY(-1);
}

.zoom-range {
  margin-left: 5px;
  
  > div {
    position: relative;
    top: 5px;
    text-align: right;
  }
}

.slider {
  background-color: lightgray;
  height: 4px;
  width: 100%;
  border-radius: 10px;
  appearance: none;
  margin: 5px 0;
  cursor: pointer;
}

.slider:focus {
  outline: none;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  height: 12px;
  width: 12px;
  background-color: rgb(135, 224, 0);
  border-radius: 100%;
  border: 1px solid green;
}

.category-dropdown {
  width: 200px;
  margin-right: 10px;
  margin-left: 5px;
}

.date-input {
  border: 1px solid $borderColor;
  border-radius: 5px;
  margin-left: 3px;
  margin-right: 10px;
}

.date-input:focus {
  outline: none;
}

.checkbox {
  margin-right: 10px;
}

.gantt-area {
  display: flex;
  height: 100%;

  > .gantt {
    height: calc(100% - #{$viewChangeHeight});
    width: calc(100% - 100px);
    z-index: 3;
    transition: $transition-time;
  }

  > .legends {
    width: 100px;
    position: absolute;
    right: 0;
    padding: 5px;

    > .legend-items {
      display: flex;
      align-items: center;
      font-size: 10px;
      margin-top: 3px;
    }
  }
}
</style>

<style >
  .gantt_row {
    cursor: pointer;
  }

  .gantt_task_content {
    cursor: default;
  }
</style>